import { Component, Vue, PropSync } from 'vue-property-decorator';
import { DataSetBase } from '@/models/dataset/DataSetBase';
import { EventErrorResponse } from '@/models/event/eventErrorResponse';


@Component
export default class StatusInfoComponent extends Vue {
    @PropSync('show', { type: Boolean }) public syncedShow!: boolean;
    @PropSync('title', { type: String }) public syncedTitle!: string;
    @PropSync('code', { type: Number }) public syncedCode!: number;
    @PropSync('error', { type: Object }) public syncedError!: EventErrorResponse;
    @PropSync('data', { type: Object }) public syncedData!: DataSetBase;

    // tslint:disable-next-line: no-empty
    public mounted() {
    }

    // tslint:disable-next-line: no-empty
    public updated() {
    }

    public close() {
        const self = this;
        this.$nextTick(() => {
            self.syncedShow = false;
        });
    }

    public formatText(inText: string) {
        return inText.replace(/\n/g, '<br />').replace(/^(\s*)/, '&nbsp;');
    }
}
